"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentCell = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsUtils = require("@cbhq/cds-utils");
var _Box = require("../layout/Box");
var _HStack = require("../layout/HStack");
var _VStack = require("../layout/VStack");
var _TextBody = require("../typography/TextBody");
var _TextHeadline = require("../typography/TextHeadline");
var _TextLabel = require("../typography/TextLabel2");
var _Cell = require("./Cell");
var _CellAccessory = require("./CellAccessory");
const _excluded = ["accessory", "title", "description", "disabled", "media", "meta", "selected", "subtitle"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ContentCell = /*#__PURE__*/(0, _react.memo)(function ContentCell(_ref) {
  let accessory = _ref.accessory,
    title = _ref.title,
    description = _ref.description,
    disabled = _ref.disabled,
    media = _ref.media,
    meta = _ref.meta,
    selected = _ref.selected,
    subtitle = _ref.subtitle,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!(0, _cdsUtils.isProduction)()) {
    if (meta && !title && !subtitle) {
      // eslint-disable-next-line no-console
      console.error('ContentCell: Cannot use `meta` without a `title` or `subtitle`.');
    }
  }
  const accessoryType = selected ? 'selected' : accessory;
  const hasTitles = Boolean(title !== null && title !== void 0 ? title : subtitle);
  return /*#__PURE__*/_react.default.createElement(_Cell.Cell, _extends({}, props, {
    accessory: accessoryType && /*#__PURE__*/_react.default.createElement(_CellAccessory.CellAccessory, {
      spacingTop: 0.5,
      type: accessoryType
    }),
    alignItems: "flex-start",
    disabled: disabled,
    media: media,
    selected: selected
  }), hasTitles && /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    alignItems: "flex-start",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_VStack.VStack, {
    className: _Cell.truncateClassName,
    flexGrow: 1,
    flexShrink: 1
  }, !!title && /*#__PURE__*/_react.default.createElement(_TextHeadline.TextHeadline, {
    as: "div",
    overflow: "truncate"
  }, title), !!subtitle && /*#__PURE__*/_react.default.createElement(_TextLabel.TextLabel2, {
    as: "div",
    overflow: "truncate",
    spacingBottom: description ? 0.5 : 0,
    spacingTop: title ? 0.5 : 0
  }, subtitle)), !!meta && /*#__PURE__*/_react.default.createElement(_Box.Box, {
    className: _Cell.truncateClassName,
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: "flex-end",
    spacingStart: 2,
    spacingTop: 0.5
  }, /*#__PURE__*/_react.default.createElement(_TextLabel.TextLabel2, {
    as: "span",
    color: "foregroundMuted",
    overflow: "truncate"
  }, meta))), !!description && /*#__PURE__*/_react.default.createElement("div", {
    className: _Cell.overflowClassName
  }, /*#__PURE__*/_react.default.createElement(_TextBody.TextBody, {
    as: "div",
    color: "foregroundMuted"
  }, description)));
});
exports.ContentCell = ContentCell;